export default "__VITE_ASSET__muLryugX__"